module.exports = __webpack_public_path__ + "static/img/image@1x-2.2c635f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/image@1x-2.png
// module id = NhR9
// module chunks = 0